/**
 * The Stripe endpoints return price and currency in a single object.
 *
 * In practice, as of this writing (2025-09-17), the currency will always match the account currency, but that's
 * an assumption, so it's best to keep the data together.
 */
export class StripePriceVO {
  constructor(private readonly amount: number, private readonly currency: string) {}

  public toJson() {
    return {
      amount: this.amount,
      currency: this.currency,
    };
  }

  public format() {
    return new Intl.NumberFormat(navigator.language, {
      style: 'currency',
      currency: this.currency,
      minimumFractionDigits: 2,
    }).format(this.amount);
  }
}
